import { createDateTimeValue, uuid } from '@elfsight/lib-utils';
import type {
  BusinessHoursProps,
  RawSpecialInterval,
  WorkingHours
} from './business-hours-types';

export const makeDefaultWorkingHours = (): WorkingHours[] => [
  {
    id: uuid(),
    timeRange: ['8:00', '17:00']
  }
];

export const businessHoursDefaultProps: BusinessHoursProps = {
  textColor: '#1B1B1B',
  openStatusColor: '#0E8B25',
  closedStatusColor: '#B82D2D',
  closedSoonStatusColor: '#FF7800',
  textStyle: {
    fontSize: 15
  },
  alignment: 'left',
  specialIntervals: [],
  dayMondayOpen: true,
  dayMondayHours: makeDefaultWorkingHours(),
  dayTuesdayOpen: true,
  dayTuesdayHours: makeDefaultWorkingHours(),
  dayWednesdayOpen: true,
  dayWednesdayHours: makeDefaultWorkingHours(),
  dayThursdayOpen: true,
  dayThursdayHours: makeDefaultWorkingHours(),
  dayFridayOpen: true,
  dayFridayHours: makeDefaultWorkingHours(),
  daySaturdayOpen: false,
  daySaturdayHours: makeDefaultWorkingHours(),
  daySundayOpen: false,
  daySundayHours: makeDefaultWorkingHours(),
  mode: 'statusWithHours',
  dayMonthFormat: 'full',
  timeZone: undefined,
  language: undefined
};

export const workingHoursItemTemplate: Omit<WorkingHours, 'id' | '$$key'> = {
  timeRange: ['8:00', '17:00']
};

export const specialIntervalItemTemplate: Omit<
  RawSpecialInterval,
  'id' | '$$key'
> = {
  startDate: createDateTimeValue(new Date(), 'date'),
  endDate: createDateTimeValue(new Date(), 'date'),
  type: 'closed',
  workingHours: makeDefaultWorkingHours(),
  description: ''
};
